import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';

import { ROUTES } from '../../constants/routes';
import { serviceRoles } from '../../utils/serviceRoles';
import { Auth } from '../../containers/Auth';
import { PublicRoute } from '../../containers/PublicRoute';
import { MainGlobalStyles, theme } from '../../styled';
import { serviceLocalStorage } from '../../utils/serviceLocalStorage';
import store from '../../store';
import '../../assets/fonts/index.css';

export const App = () => {
  const currentPrivateRouteByRole = () => {
    if (!+serviceLocalStorage.getUserRoleID()) {
      window.location.href = ROUTES.LOGIN;
    }
    return serviceRoles(+serviceLocalStorage.getUserRoleID()).privateRoute;
  };

  return (
    <Provider store={store}>
      <MainGlobalStyles />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Switch>
            <PublicRoute path={['/auth*']} exact={true} component={Auth} />
            <Route render={() => currentPrivateRouteByRole()} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};
